import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';

// Clear admin UI preference on launch (auth session is restored by AuthContext so user stays logged in)
try {
  localStorage.removeItem('adminSelectedCity');
} catch (_) {}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
